var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi_table--column"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.kpiRowInfo),function(row,key){return [(_vm.doesUserHaveAccess(row.permissionCheck))?_c('div',{key:key,staticClass:"kpi_table--column--cell"},[_c('p',[_vm._v(_vm._s(_vm.calculateAverage(key)))])]):_vm._e()]})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi_table--column--heading"},[_c('p',[_vm._v("Average")])])
}]

export { render, staticRenderFns }